import { DatePicker } from "antd";
import React, { useState } from "react";
import AutoCompleteSearch from "../../../../common/components/AutoComplete/AutoCompleteSearch";
import { ExpandSVG } from "../../../../common/components/icons/SVGIcon";

const dateFormat = "MM/DD/YYYY";

const MeaningfulUseFilter = ({ autoCompleteOptions, valueSearch, providers, onChangeStartDate, onChangeEndDate, onChangeProvider, handlePopulate, handleExport }) => {
  const [search, setSearch] = useState("");

  const changeSearch = (value) => {
    setSearch(value);
    valueSearch(value);
  };

  return (
    <div className="filterContainer">
      <div className="searchFieldContainer">
        <div className="searchField">
          <AutoCompleteSearch
            isNotTargetInput={true}
            value={search}
            handlePopulate={(item) => handlePopulate && handlePopulate(item)}
            title="Patient-Search"
            options={autoCompleteOptions}
            handleSearch={(value) => changeSearch(value)}
            placeholder="Search Patient"
            keyLabel="patient_name"
            actionLabel="Search"
            backgroundWhite={"white"}
          />
        </div>
      </div>

      <div className="statusFilterContainer">
        <div className="statusFilter" style={{ minWidth: "200px" }}>
          <DatePicker format={dateFormat} placeholder="Start Date" suffixIcon={<ExpandSVG />} onChange={onChangeStartDate} />
        </div>
        <div className="statusFilter" style={{ minWidth: "200px", marginLeft: "10px" }}>
          <DatePicker format={dateFormat} placeholder="End Date" suffixIcon={<ExpandSVG />} onChange={onChangeEndDate} />
        </div>
        <div className="statusFilter" style={{ marginLeft: "10px" }}>
          <button className="common-btn" style={{ justifyContent: "center" }} onClick={handleExport}>
            Export
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeaningfulUseFilter;
